export const REFRESH_INTERVAL = 60 * 1000 * 5; // 5 minutes
export const NOTES_MAX_LENGTH = 2000; // Character limit for notes fields (monitoring points, assets, assemblies)
